import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import { get } from "lodash";
import { ISSUE_ACTION } from "../constant";
import { transformIssueListPayload } from "../helper";

export const setIssueStatusAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.ISSUE_ACTION_CHANGE_STATUS_START
    });
    return requestMethod(apiServices.setIssueStatus(params))
      .then(response => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_ACTION_CHANGE_STATUS_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_ACTION_CHANGE_STATUS_FAILURE
        });
      });
  };
};

export const postCommentAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.POST_COMMENT_START
    });
    return requestMethod(apiServices.postComment(params))
      .then(response => {
        dispatch({
          type: ISSUE_ACTION.POST_COMMENT_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.POST_COMMENT_FAILURE
        });
      });
  };
};

export const issueClarificationAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.ISSUE_CLARIFICATION_START
    });
    return requestMethod(apiServices.issueClarification(params))
      .then(response => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_CLARIFICATION_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_CLARIFICATION_FAILURE
        });
      });
  };
};

export const forwardToTeamAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.ISSUE_CLARIFICATION_START
    });
    return requestMethod(apiServices.forwardToTeam(params))
      .then(response => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_CLARIFICATION_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_CLARIFICATION_FAILURE
        });
      });
  };
};

export const replyAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.ISSUE_CLARIFICATION_START
    });
    return requestMethod(apiServices.reply(params))
      .then(response => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_CLARIFICATION_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_CLARIFICATION_FAILURE
        });
      });
  };
};

export const guestListAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.ISSUE_GUEST_LIST_START
    });
    return requestMethod(apiServices.guestList(params))
      .then(response => {
        const data = {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: ISSUE_ACTION.ISSUE_GUEST_LIST_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_GUEST_LIST_FAILURE
        });
      });
  };
};

export const getActions = (requestMethod = request, params) => {
  return function(dispatch) {
    // dispatch({
    //   type: ISSUE_ACTION.ISSUE_GUEST_LIST_START
    // });
    return requestMethod(apiServices.getActions(params))
      .then(response => {
        const data = {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        // dispatch({
        //   type: ISSUE_ACTION.ISSUE_GUEST_LIST_SUCCESS,
        //   payload: data
        // });
        return data;
      })
      .catch(() => {
        // dispatch({
        //   type: ISSUE_ACTION.ISSUE_GUEST_LIST_FAILURE
        // });
      });
  };
};

export const getDownloadIssueListAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_START
    });
    return requestMethod(apiServices.downloadIssuesListReport(params))
      .then(response => {
        const data = {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        if (!get(data, "data")) {
          dispatch({
            type: ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_FAILURE
          });
        }
        return data;
      })
      .catch(error => {
        console.log("Error while fetching issue list - ", error.message);
        dispatch({
          type: ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_FAILURE
        });
      });
  };
};

export const downloadIssueListReportsAction = (
  requestMethod = request,
  data
) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_START
    });
    return requestMethod(apiServices.downloadReports(data))
      .then(resp => {
        const { data } = resp;
        if (get(data, "status")) {
          dispatch({
            type: ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_SUCCESS,
            payload: get(data, "data.url")
          });
        }
        return resp;
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_FAILURE
        });
      });
  };
};

export const clearIssueListDownloadAction = function() {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.CLEAR_ISSUE_LIST_REPORT_DOWNLOAD
    });
  };
};

export const getIssueStakeHolderAction = (requestMethod = request, data) => {
  return requestMethod(
    apiServices.getIssueStokeHolderInfo(transformIssueListPayload(data))
  ).then(resp => {
    return resp;
  });
};
